import type {Flow} from './flow.ts';
import {TimeSeries, TimeSeriesS} from './history.ts';

export type FlowHistory = Array<{year: number; flows: Flow[]}>;

export function toTimeSeries(fh: FlowHistory): TimeSeriesS<number> {
  /*
   eslint @typescript-eslint/require-array-sort-compare: "off"
   */
  const years = [...new Set(fh.map(e => e.year))].sort();
  const names = [...new Set(fh.flatMap(e => e.flows.map(f => f.name)))].sort();

  return new TimeSeriesS<number>(
    names.map(
      name => new TimeSeries<number>(
        name,
        years.map(
          year => ({
            year,
            value: fh
              .find(e => e.year === year)
              ?.flows
              ?.find(f => f.name === name)
              ?.amount ?? 0,
          }),
        ),
      ),
    ),
  );
}
